<!--
 * @Author: 姚林刚
 * @Date: 2023-04-25 10:08:01
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-04-26 09:24:32
 * @Description: file content
-->
<template>
  <div class="block_panel">
    <div class="b_title">{{ title }}</div>
    <div class="b_container">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: ''
      },
      height: {
        type: String,
        default: ''
      },
    },
  }
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}

@function vh($px) {
  @return ($px / 1080) * 100vh;
}

@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.block_panel {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .b_title {
    font-size: fontSize(18);
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-style: italic;
    color: #FFFFFF;
    width: 100%;
    height: vh(44);
    background: url("../../assets/images/common/bg_title_top.png") no-repeat;
    background-size: 100% 100%;
    padding-left: vw(35);
    line-height: vh(38);
    position: relative;
    display: flex;
    padding-bottom: vh(8);
    align-items: center;
    margin-bottom: vh(8);
    padding-top: vh(4);
    &:before {
      content: '';
      position: absolute;
      width: vw(3);
      height: vh(18);
      background: url("../../assets/images/common/icon_titlename.png") no-repeat;
      background-size: 100% 100%;
      left: vw(26);
    }
    &:after {
      content: '';
      position: absolute;
      width: vw(36);
      height: vh(5);
      background: url("../../assets/images/common/icon_title.png") no-repeat;
      background-size: 100% 100%;
      right: vw(21);
      top: vh(4);
    }
  }
  .b_container {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
  }
}
</style>